var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"videoPlayer",staticClass:"video-js vjs-16-9 w-100",style:({ height: _vm.height, width: _vm.width })},[_c('p',{staticClass:"vjs-no-js"},[_vm._v("To view this video please enable JavaScript")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c6ba304","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/video-player.vue
// module id = mSOO
// module chunks = 0 38 111 112 118